export default {
  cmsData: {},
  goodList: [],
  rasierList: [],
  consultantList: [],
  menuList: [],
  shopkeeperList: [],
  shopkeeperDetail: {},
  storeList: [],
  commentList: {}
}
